import React from 'react'
import {
    Box,
    Typography,
    IconButton,
    Menu,
    MenuItem,
    Button
} from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import EditIcon from '@mui/icons-material/Edit'
import MoreHorizIcon from '@mui/icons-material/MoreHoriz'
import DeleteIcon from '@mui/icons-material/Delete'
import PeopleIcon from '@mui/icons-material/People'

const TemplateSectionEditorHeader = ({
    templateTitle,
    templateType,
    exampleOutlineIds,
    onBackClick,
    onEditClick,
    onTrainingSetsClick,
    menuAnchorEl,
    onMenuClick,
    onMenuClose,
    onDeleteClick,
    onUsersClick,
    usersCount = 0
}) => {
    return (
        <>
            {/* Section Editor Header */}
            <Box
                sx={{
                    padding: '16px 20px 16px 20px',
                    borderBottom: '1px solid #e5e7eb',
                    backgroundColor: '#ffffff',
                    flexShrink: 0
                }}
            >
                {/* Back Arrow and Title Row */}
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '12px',
                        lineHeight: '20px'
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            lineHeight: '20px'
                        }}
                    >
                        <IconButton
                            onClick={onBackClick}
                            sx={{
                                padding: '4px',
                                color: '#374151',
                                '&:hover': {
                                    backgroundColor: '#f3f4f6'
                                }
                            }}
                        >
                            <ArrowBackIcon sx={{ fontSize: '18px' }} />
                        </IconButton>
                        <Box 
                            sx={{ 
                                display: 'flex', 
                                alignItems: 'center', 
                                gap: '4px', 
                                lineHeight: '20px' 
                            }}
                        >
                            <Typography
                                variant="body1"
                                sx={{
                                    fontWeight: 600,
                                    fontSize: '16px',
                                    color: '#111827',
                                    lineHeight: '20px'
                                }}
                            >
                                {templateTitle}
                            </Typography>
                            <IconButton
                                onClick={onEditClick || (() => {})}
                                sx={{
                                    padding: '4px',
                                    color: '#4338CA',
                                    '&:hover': {
                                        backgroundColor: '#f3f4f6'
                                    },
                                    lineHeight: '20px'
                                }}
                            >
                                <EditIcon sx={{ fontSize: '18px' }} />
                            </IconButton>
                        </Box>
                        <Typography
                            variant="body2"
                            sx={{
                                color: '#6b7280',
                                fontSize: '14px',
                                fontWeight: 500,
                                lineHeight: '20px'
                            }}
                        >
                            •
                        </Typography>
                        <Typography
                            variant="body2"
                            sx={{
                                color: '#6b7280',
                                fontSize: '14px',
                                fontWeight: 500,
                                lineHeight: '20px'
                            }}
                        >
                            {templateType.toUpperCase()}
                        </Typography>
                        <Typography
                            variant="body2"
                            sx={{
                                color: '#6b7280',
                                fontSize: '14px',
                                fontWeight: 500,
                                lineHeight: '20px'
                            }}
                        >
                            •
                        </Typography>
                        <Typography
                            component="button"
                            onClick={onTrainingSetsClick || (() => {})}
                            sx={{
                                background: 'none',
                                border: 'none',
                                padding: 0,
                                color: '#3b82f6',
                                fontSize: '14px',
                                lineHeight: '20px',
                                fontWeight: 500,
                                cursor: 'pointer',
                                '&:hover': {
                                    textDecoration: 'underline'
                                }
                            }}
                        >
                            {exampleOutlineIds.length} training set{exampleOutlineIds.length !== 1 ? 's' : ''}
                        </Typography>
                    </Box>
                    <Box sx={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <Button
                            variant="contained"
                            startIcon={<PeopleIcon />}
                            onClick={onUsersClick}
                            sx={{
                                backgroundColor: '#ffffff',
                                borderColor: '#d1d5db',
                                color: '#374151',
                                height: '34px',
                                borderRadius: '6px',
                                fontSize: '12px',
                                fontWeight: 600,
                                textTransform: 'none',
                                padding: '0 16px',
                                boxShadow: 'none',
                                border: '1px solid #e5e7eb',
                                '&:hover': {
                                    backgroundColor: '#f3f4f6',
                                    boxShadow: 'none'
                                },
                                '& .MuiButton-startIcon': {
                                    marginRight: '8px',
                                    color: '#6b7280',
                                    '& svg': {
                                        fontSize: '16px',
                                    },
                                },
                            }}
                        >
                            Users · {usersCount}
                        </Button>
                        <IconButton
                            onClick={onMenuClick}
                            sx={{
                                padding: '4px',
                                color: '#9CA3AF',
                                '&:hover': {
                                    backgroundColor: '#f3f4f6'
                                },
                                lineHeight: '20px'
                            }}
                        >
                            <MoreHorizIcon sx={{ fontSize: '18px' }} />
                        </IconButton>
                    </Box>
                </Box>
            </Box>

            {/* Three Dots Menu */}
            <Menu
                anchorEl={menuAnchorEl}
                open={Boolean(menuAnchorEl)}
                onClose={onMenuClose}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                PaperProps={{
                    sx: {
                        boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.1)',
                        borderRadius: '8px',
                        minWidth: '140px',
                        border: '1px solid #e5e7eb'
                    }
                }}
                sx={{
                    '& .MuiList-root': {
                        padding: '4px 0'
                    }
                }}
            >
                <MenuItem 
                    onClick={onDeleteClick} 
                    sx={{ 
                        padding: '8px 12px',
                        fontSize: '14px',
                        minHeight: 'auto',
                        color: '#dc2626',
                        '&:hover': {
                            backgroundColor: '#fef2f2'
                        }
                    }}
                >
                    <DeleteIcon sx={{ mr: '8px', fontSize: '16px', color: '#dc2626' }} />
                    Delete
                </MenuItem>
            </Menu>
        </>
    )
}

export default TemplateSectionEditorHeader